import {useEffect, useState} from 'react';

import {desktopSize, mobileBigSize, resize} from './models/constants';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= desktopSize,
    isBigMobile: window.innerWidth >= mobileBigSize,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= desktopSize,
        isBigMobile: window.innerWidth >= mobileBigSize,
      });
    };

    window.addEventListener(resize, handleResize);

    return () => {
      window.removeEventListener(resize, handleResize);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;
